export const REPORT_REASON_CODES = [
  'wrong_rating',
  'advertisement_spam',
  'character_underage',
  'low_quality',
  'promote_self_harm',
  'illegal_content',
  'impersonates_real_person',
  'plagiarism',
  'other'
];

const CHARACTER_ONLY_REASONS = new Set([
  'character_underage',
  'impersonates_real_person'
]);

export const getReportReasonsForKind = (contentKind) => {
  if (contentKind === 'character') return [...REPORT_REASON_CODES];
  return REPORT_REASON_CODES.filter((code) => !CHARACTER_ONLY_REASONS.has(code));
};
